import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { IpIcon, VendorIcon } from "../../shared/assets/icons";
import Client from "../../shared/assets/icons/Client";
import { IconButton, Tooltip } from "@mui/material";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import { LocationOnOutlined } from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Styles from "../../styles/vendorDashboard.module.css";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AssistantPhotoOutlinedIcon from "@mui/icons-material/AssistantPhotoOutlined";
import Person4OutlinedIcon from "@mui/icons-material/Person4Outlined";
const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  const activeMenu = location.pathname.split("/").pop();
  const role = localStorage.getItem("role");

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div
        className={`bg-gray-950 text-white fixed h-full z-50
          ${isOpen ? "w-64" : "w-14"}
          transition-all duration-300`}
      >
        <div className="p-4 flex justify-between items-center">
          <h2 className={`text-xl font-bold ${isOpen ? "block" : "hidden"}`}>
            {role === "-1"
              ? "Super Admin"
              : role === "0"
                ? "CSM"
                : role == 1
                  ? "BD"
                  : role == 7
                    ? "Designer"
                    : role == "3"
                      ? "Purchase"
                      : role == "4"
                        ? "Operations"
                        : "MT"}
          </h2>
          <button onClick={toggleSidebar} className=" focus:outline-none">
            {isOpen ? (
              <FaTimes className="h-6 w-6" />
            ) : (
              <FaBars className="h-6 w-6" />
            )}
          </button>
        </div>
        <ul
          className={`mt-4 space-y-4 h-[90vh] ${Styles["custom-scrollbar"]}`}
          style={{ overflow: "overlay" }}
        >
          {role === "-1" ? (
            // Case where role === "-1" (admin or super user)
            <>
              <Link to="/adminportal/dashboard">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "dashboard"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Dashboard">
                    <IconButton>
                      <DashboardIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Dashboard
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/vendorDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "vendorDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Vendor">
                    <IconButton>
                      <VendorIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Vendor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/deliveryCenters">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "deliveryCenters"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Delivery Centers">
                    <IconButton>
                      <WarehouseOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Delivery Centers
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/clientDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "clientDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Organization">
                    <IconButton>
                      <Client color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Organization Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-partner">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-partner"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Partner">
                    <IconButton>
                      <IpIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    IP Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/contractor">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "contractor"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Contractor">
                    <IconButton>
                      <Person4OutlinedIcon
                        sx={{ color: "white", marginRight: "4px" }}
                      />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Contractor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/itemMaster">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "itemMaster"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Item Master">
                    <IconButton>
                      <EngineeringOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Item Master
                  </span>
                </li>
              </Link>

              <Link to="/adminportal/team">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "team" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Users">
                    <IconButton>
                      <Diversity1OutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Team
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/Enquiry">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "Enquiry" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Enquiry">
                    <IconButton>
                      <RequestQuoteOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Enquiry
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/campaign">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "campaign" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Campaign">
                    <IconButton>
                      <CampaignOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Campaign
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/map">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "map" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Filter Vendors">
                    <IconButton>
                      <LocationOnOutlined
                        sx={{ color: "white", size: "15px" }}
                      />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Map Filter
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/payments">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "payments" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Payments">
                    <IconButton>
                      <CurrencyRupeeIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Payments
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/PDI">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "PDI" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="PDI">
                    <IconButton>
                      <TroubleshootIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    PDI
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/locationsVerification">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "locationsVerification"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Upload Store Locations">
                    <IconButton>
                      <UploadFileOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Upload Store Locations
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/purchaseOrder">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "purchaseOrder"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Generate PO">
                    <IconButton>
                      <ReceiptLongIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Generate PO
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-flag">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-flag"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Flag">
                    <IconButton>
                      <AssistantPhotoOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Installation Flag
                  </span>
                </li>
              </Link>
            </>
          ) : role === "0" ? ( // Case where role === "0" (normal user with restricted access)
            <>
              <Link to="/adminportal/vendorDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "vendorDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Vendor">
                    <IconButton>
                      <VendorIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Vendor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-partner">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-partner"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Partner">
                    <IconButton>
                      <IpIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    IP Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/Enquiry">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "Enquiry" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Enquiry">
                    <IconButton>
                      <RequestQuoteOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Enquiry
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/campaign">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "campaign" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Campaign">
                    <IconButton>
                      <CampaignOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Campaign
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/PDI">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "PDI" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="PDI">
                    <IconButton>
                      <TroubleshootIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    PDI
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-flag">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-flag"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Flag">
                    <IconButton>
                      <AssistantPhotoOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Installation Flag
                  </span>
                </li>
              </Link>
            </>
          ) : role === "1" ? (
            // Case where role === "0" (normal user with restricted access)
            <>
              <Link to="/adminportal/vendorDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "vendorDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Vendor">
                    <IconButton>
                      <VendorIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Vendor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/clientDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "clientDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Organization Details">
                    <IconButton>
                      <Client color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Organization Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-partner">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-partner"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Partner">
                    <IconButton>
                      <IpIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    IP Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/Enquiry">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "Enquiry" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Enquiry">
                    <IconButton>
                      <RequestQuoteOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Enquiry
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/campaign">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "campaign" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Campaign">
                    <IconButton>
                      <CampaignOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Campaign
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/locationsVerification">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "locationsVerification"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Upload Store Locations">
                    <IconButton>
                      <UploadFileOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Upload Store Locations
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-flag">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-flag"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Flag">
                    <IconButton>
                      <AssistantPhotoOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Installation Flag
                  </span>
                </li>
              </Link>
            </>
          ) : role === "3" ? (
            // ✅ UPDATED: Role 3 menu – now includes Vendor Details
            <>
              <Link to="/adminportal/vendorDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "vendorDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Vendor">
                    <IconButton>
                      <VendorIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Vendor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/Enquiry">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "Enquiry" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Enquiry">
                    <IconButton>
                      <RequestQuoteOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Enquiry
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/campaign">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "campaign" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Campaign">
                    <IconButton>
                      <CampaignOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Campaign
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/purchaseOrder">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "purchaseOrder"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Generate PO">
                    <IconButton>
                      <ReceiptLongIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Generate PO
                  </span>
                </li>
              </Link>
            </>
          ) : role === "4" ? (
            <>
              <Link to="/adminportal/vendorDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "vendorDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Vendor">
                    <IconButton>
                      <VendorIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Vendor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-partner">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-partner"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Partner">
                    <IconButton>
                      <IpIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    IP Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/Enquiry">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "Enquiry" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Enquiry">
                    <IconButton>
                      <RequestQuoteOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Enquiry
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/campaign">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "campaign" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Campaign">
                    <IconButton>
                      <CampaignOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Campaign
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/PDI">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "PDI" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="PDI">
                    <IconButton>
                      <TroubleshootIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    PDI
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-flag">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-flag"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Flag">
                    <IconButton>
                      <AssistantPhotoOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Installation Flag
                  </span>
                </li>
              </Link>
            </>
          ) : role === "7" ? (
            <>
              <Link to="/adminportal/campaign">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "campaign" ? "bg-[var(--heading-color)]" : ""
                  }`}
                >
                  <Tooltip title="Campaign">
                    <IconButton>
                      <CampaignOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Campaign
                  </span>
                </li>
              </Link>
            </>
          ) : role == "6" ? (
            <>
              <Link to="/adminportal/locationsVerification">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "locationsVerification"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Upload Store Locations">
                    <IconButton>
                      <UploadFileOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Upload Store Locations
                  </span>
                </li>
              </Link>
            </>
          ) : (
            // Case where any other role (not "-1" or "0")
            <>
              <Link to="/adminportal/vendorDetails">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "vendorDetails"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Vendor">
                    <IconButton>
                      <VendorIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Vendor Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/installation-partner">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "installation-partner"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Installation Partner">
                    <IconButton>
                      <IpIcon color="white" size="25" />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    IP Details
                  </span>
                </li>
              </Link>
              <Link to="/adminportal/locationsVerification">
                <li
                  className={`py-2 px-2 flex items-center cursor-pointer mb-3 ${
                    activeMenu === "locationsVerification"
                      ? "bg-[var(--heading-color)]"
                      : ""
                  }`}
                >
                  <Tooltip title="Upload Store Locations">
                    <IconButton>
                      <UploadFileOutlinedIcon style={{ color: "white" }} />
                    </IconButton>
                  </Tooltip>
                  <span className={`${isOpen ? "block" : "hidden"} ml-3`}>
                    Upload Store Locations
                  </span>
                </li>
              </Link>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
